export default __webpack_public_path__ + "static/media/tile-1-long.fb40d6b7.png";